<App params={ f7params }>

  <!-- Your main view, should have "view-main" class -->
  <!-- <View main class="safe-areas" url="/" masterDetailBreakpoint={800} /> -->
  <View main class="safe-areas" url="/" />

</App>
<script>
  import {
    App,
    View,
  } from 'framework7-svelte';

  import routes from './routes';
  import { Device } from 'framework7';
  // Framework7 Parameters
  let f7params = {
    name: 'stock', // App name
    theme: Device.desktop ? 'aurora' : 'auto', // Automatic theme detection
    autoDarkTheme: true, // Automatic Dark Theme
    routes: routes, // App routes
  };

  if (window.navigator.standalone) {
    document.body.classList.add('standalone');
  }
</script>
<style>
</style>